// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

/**
 * @description Documentation only
 */
export const getWebhookevents200Schema = z.unknown();

export const getWebhookeventsQueryResponseSchema = z.lazy(() => getWebhookevents200Schema);
